import { createSelector } from 'reselect';

export const domain = ({ router }) => router;
export const getLocation = createSelector(domain, ({ location }) => location);
export const getPathName = createSelector(getLocation, ({ pathname }) => pathname);
